export default "__VITE_ASSET__fff31373__"